import ForgotPasswordForm from './ForgotPasswordForm';
import {actions, connect, selectors} from '../../../stores'

const mapStateToProps = state => ({
  isForgotPasswordConfirm: selectors.auth.selectForgotPasswordConfirm(state),
  isForgotPasswordByEmail: selectors.auth.selectForgotPasswordByEmail(state),
  isSupportProposal: selectors.auth.selectSupportProposal(state),
  isLoading: selectors.auth.selectIsLoading(state),
  resetPasswordRequired: selectors.auth.selectResetPasswordRequired(state)
});

const mapDispatchToProps = dispatch => ({
  resetPassword: payload => dispatch(actions.auth.resetPassword(payload)),
  resetPasswordByEmail: payload => dispatch(actions.auth.resetPasswordByEmail(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordForm);
